import React, { useContext } from "react";
import { Link, Typography } from "@material-ui/core";

import { ALL_ACCESS_INVESTOR_URL } from "constants/index";
import { AppContext } from "contexts";
import { computeBuyerFee } from "lib/finance";
import { formatCurrencyAmount } from "lib/format";

interface TransactionFeeNoticeProps {
  isBuyNow: boolean;
  price: number;
}

const TransactionFeeNotice: React.FC<TransactionFeeNoticeProps> = ({
  isBuyNow,
  price,
}) => {
  const { user } = useContext(AppContext);
  const buyerFee = formatCurrencyAmount("USD", computeBuyerFee(price));
  return (
    <Typography variant="caption" style={{ lineHeight: "1rem" }}>
      {!!user && !user.isAAI && (
        <>
          *A transaction fee of {buyerFee} will be added at closing
          {!isBuyNow && " if your offer is accepted by the owner"}. Want to have
          these fees waived?{" "}
          <Link
            color="primary"
            variant="caption"
            href={ALL_ACCESS_INVESTOR_URL}
            target="_blank"
            rel="noopener noreferrer"
            underline="always"
          >
            Become an All Access member today
          </Link>
        </>
      )}
    </Typography>
  );
};

export default TransactionFeeNotice;
